(function() {
    SR.component.extend('srUpdateSuccess', srUpdateSuccess);

    function srUpdateSuccess() {
        var $tip = $('<div class="sr-tips update-success">'+ SR.permissions.title +'已完成升级，您可以<a href="#" class="J_refresh">立即刷新</a>，或等到下次打开，来获取最新功能。<div class="close_btn J_close">✕</div></div>');
        SR.dom.$body.append($tip);
        $tip.fadeIn(200);

        $('.J_refresh').on('click', function(e) {
            e.preventDefault();
            location.reload();
        });

        $('.J_close').on('click', function() {
            hideTip();
        });

        function hideTip() {
            $tip.fadeOut(200);
        }
    }
})();